// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountOrderMatrixCoverageDto
 */
export interface IAccountOrderMatrixCoverageDto {
    /**
     * 
     * @type {Date}
     * @memberof IAccountOrderMatrixCoverageDto
     */
    coverage_date_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IAccountOrderMatrixCoverageDto
     */
    coverage_date_end?: Date;
}

/**
 * Check if a given object implements the IAccountOrderMatrixCoverageDto interface.
 */
export function instanceOfIAccountOrderMatrixCoverageDto(value: object): value is IAccountOrderMatrixCoverageDto {
    return true;
}

export function IAccountOrderMatrixCoverageDtoFromJSON(json: any): IAccountOrderMatrixCoverageDto {
    return IAccountOrderMatrixCoverageDtoFromJSONTyped(json, false);
}

export function IAccountOrderMatrixCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountOrderMatrixCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage_date_start': json['coverage_date_start'] == null ? undefined : (new Date(json['coverage_date_start'])),
        'coverage_date_end': json['coverage_date_end'] == null ? undefined : (new Date(json['coverage_date_end'])),
    };
}

export function IAccountOrderMatrixCoverageDtoToJSON(json: any): IAccountOrderMatrixCoverageDto {
    return IAccountOrderMatrixCoverageDtoToJSONTyped(json, false);
}

export function IAccountOrderMatrixCoverageDtoToJSONTyped(value?: IAccountOrderMatrixCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coverage_date_start': value['coverage_date_start'] == null ? undefined : ((value['coverage_date_start']).toISOString().substring(0,10)),
        'coverage_date_end': value['coverage_date_end'] == null ? undefined : ((value['coverage_date_end']).toISOString().substring(0,10)),
    };
}

